export default "__VITE_ASSET__C_D1Q$IC__"